export default {
    yes: "Sim",
    no: "Não"
}